import React, { Component } from 'react';
import { DashboardLayout } from '../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';

class TutorPaymentMethod extends Component {
    render() {
        return (<DashboardLayout>
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">TutorPaymentMethod</h2>
                        </div>
                    </div>
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(TutorPaymentMethod);